function newsOpen() {
	let imgOpen = document.getElementsByClassName('news-mini__img')

	for (let i = 0; i < imgOpen.length; i++) {
		imgOpen[i].addEventListener('click', function () {
			this.classList.toggle('active')
			let newsItem = document.getElementsByClassName('news-mini__content')[i]
			if (newsItem.style.maxHeight) {
				newsItem.style.maxHeight = null
				imgOpen[i].style.transform = 'rotate(360deg)'
			} else {
				newsItem.style.maxHeight = '900px'
				imgOpen[i].style.transform = 'rotate(180deg)'
			}
		})
	}
}
